import React from 'react'
import { Table, Button } from 'antd'
import { MembershipV3DarkChecked } from '../icons/onboarding'
import './AppleMembership.css'

const AppleMembership = (props) => {
  const { current, onChange, selectable, price } = props
  const [initialMembership, setInitialMembership] = React.useState(current)

  const planList = [
    {
      name: 'CONDITION',
      membership: 'Condition Assessment',
      background: 'linear-gradient(88deg, #9DA5AF 4.45%, #9DA5AF 113.97%)',
      price: 6500,
      priceInfo: ['$6k', '$500']
    },
    {
      name: 'FITNESS',
      membership: 'Fitness Assessment',
      background: 'linear-gradient(88deg, #9DA5AF 4.45%, #9DA5AF 113.97%)',
      price: 6500,
      priceInfo: ['$6k', '$500']
    },
    {
      name: 'HEALTHSPAN',
      membership: 'evaluation2',
      background: 'linear-gradient(299deg, #DFA579 0%, #A2604E 70.04%)',
      price: 11500,
      priceInfo: ['$11k', '$500']
    }
  ]

  const columns = [
    {
      title: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}
        >
          <span
            style={{
              fontSize: '20px',
              color: '#223064',
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            Services Offered
          </span>
        </div>
      ),
      dataIndex: 'feature',
      key: 'feature',
      width: 550
    },
    ...planList.map((plan) => {
      const getClassNames = (membership) => {
        switch (membership) {
          case 'Condition Assessment':
            return {
              nameClass: 'condition-text',
              priceClass: 'program-price'
            }
          case 'Fitness Assessment':
            return {
              nameClass: 'fitness-text',
              priceClass: 'program-price'
            }
          case 'evaluation2':
            return {
              nameClass: 'healthspan-text',
              priceClass: 'program-price'
            }
          default:
            return {
              nameClass: 'default-text',
              priceClass: 'program-price'
            }
        }
      }

      const { nameClass, priceClass } = getClassNames(plan.membership)

      return {
        title: (
          <div className="header-div" style={{ textAlign: 'center' }}>
            <span className={nameClass}>{plan.name}</span>
            <span className={priceClass}>
              ${plan.price.toLocaleString()}
            </span>
            {!selectable && plan.membership === current && (
              <div style={{ position: 'relative', marginBottom: '10px', width: '100%' }}>
                <div className="tag-apple">CURRENT</div>
                <br />
              </div>
            )}
            <span>
              {selectable && (
                <Button
                  style={{
                    border: '1.5px solid #2B4B8F'
                  }}
                  type="primary"
                  className={`select-btn ${
                    plan.membership === current ? 'selected-btn' : ''
                  }`}
                  ghost={plan.membership !== current}
                  size="large"
                  onClick={() => selectable && onChange(plan)}
                >
                  {plan.membership === current ? (
                    <span>
                      <GreenChecked /> SELECTED
                    </span>
                  ) : (
                    'SELECT'
                  )}
                </Button>
              )}
            </span>
          </div>
        ),
        dataIndex: plan.membership,
        key: plan.membership,
        width: 400,
        align: 'center',
        className: plan.membership === current ? 'highlighted-column' : '',
        render: (value) => renderCell(value)
      }
    })
  ]

  const dataSource = [
    {
      key: '1',
      feature:
        'Expert driven lifestyle assessment & 6 weeks of programming designed to:',
      'Condition Assessment':
        'Enhance function/health after injury, surgery or a medical condition',
      'Fitness Assessment':
        'Enhance performance (and resilience to injury) in fitness and athletics',
      evaluation2:
        'Broaden the definition of fitness to include maximizing the predictors of healthspan'
    },
    {
      key: '2',
      feature: 'AREAS TESTED',
      'Condition Assessment':
        '4 Healthspan Domains™ + Blood Work (Varies With Needs)',
      'Fitness Assessment': '4 Areas + Blood Work',
      evaluation2: '7 Areas + Blood Work'
    },
    {
      key: '3',
      feature: 'Body Composition',
      'Condition Assessment':
        "Apeiron Life's team will select 4 core areas based on your condition or injury.",
      'Fitness Assessment': true,
      evaluation2: true
    },
    {
      key: '4',
      feature: 'Muscle fitness',
      'Condition Assessment': 'Recovery Focused',
      'Fitness Assessment': 'Recovery Focused',
      evaluation2: true
    },
    {
      key: '5',
      feature: 'Blood Work',
      'Condition Assessment': 'Handled at Apple',
      'Fitness Assessment': 'Handled at Apple',
      evaluation2: true
    },
    {
      key: '6',
      feature: 'Mobility',
      'Condition Assessment':
        "Apeiron Life's team will select 4 core areas based on your condition or injury.",
      'Fitness Assessment': true,
      evaluation2: true
    },
    {
      key: '7',
      feature: 'Cardiovascular fitness',
      'Condition Assessment':
        "Apeiron Life's team will select 4 core areas based on your condition or injury.",
      'Fitness Assessment': true,
      evaluation2: true
    },
    {
      key: '8',
      feature: 'Balance',
      'Condition Assessment':
        "Apeiron Life's team will select 4 core areas based on your condition or injury.",
      'Fitness Assessment': '-',
      evaluation2: true
    },
    {
      key: '9',
      feature: 'Sleep and Stress',
      'Condition Assessment':
        "Apeiron Life's team will select 4 core areas based on your condition or injury.",
      'Fitness Assessment': '-',
      evaluation2: true
    },
    {
      key: '10',
      feature: 'Cognition',
      'Condition Assessment':
        "Apeiron Life's team will select 4 core areas based on your condition or injury.",
      'Fitness Assessment': '-',
      evaluation2: true
    },
    {
      key: '11',
      feature: 'Bone Density',
      'Condition Assessment':
        "Apeiron Life's team will select 4 core areas based on your condition or injury.",
      'Fitness Assessment': '-',
      evaluation2: true
    },
    {
      key: '12',
      feature: 'Self guided exercise program tailored to your goals',
      'Condition Assessment': '6 Weeks',
      'Fitness Assessment': '6 Weeks',
      evaluation2: '6 Weeks'
    },
    {
      key: '13',
      feature: 'Sport-specific conditioning (Skiing, golf, cycling, etc.)',
      'Condition Assessment': '-',
      'Fitness Assessment': true,
      evaluation2: true
    },
    {
      key: '14',
      feature: 'Adaptive coaching (app)',
      'Condition Assessment': 'Basic Tracking',
      'Fitness Assessment': 'Basic Tracking',
      evaluation2: 'Full'
    },
    {
      key: '15',
      feature: 'Live training or nutrition session',
      'Condition Assessment': '2',
      'Fitness Assessment': '2',
      evaluation2: '2'
    }
  ]

  const renderCell = (value) => {
    if (value === true) {
      return <MembershipV3DarkChecked />
    } else if (value === false || value === '-') {
      return <span>-</span>
    } else if (typeof value === 'object' && value !== null) {
      return (
        <span
          style={{
            color: '#666',
            fontSize: '12px',
            textAlign: 'center',
            display: 'block'
          }}
        >
          {value.note}
        </span>
      )
    } else if (
      value === 'Recovery Focused'
    ) {
      return <span style={{ color: '##FB8102' }}>{value}</span>
    } else {
      return <span>{value}</span>
    }
  }

  return (
    <div
      className="apple-membership-table"
      style={{
        borderRadius: '20px',
        overflow: 'hidden',
        margin: '20px 0px 60px 0px'
      }}
    >
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered
      />
    </div>
  )
}

export default AppleMembership

function GreenChecked(props) {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.0625 4.4375L3.25 6.625L8.9375 0.9375"
        stroke="#05B800"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
